// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyDbKyc3eJ8gNTkTiV6bz6yqQwUm6uz_rTU",
  authDomain: "japantour-1cbe7.firebaseapp.com",
  projectId: "japantour-1cbe7",
  storageBucket: "japantour-1cbe7.firebasestorage.app",
  messagingSenderId: "1097608950384",
  appId: "1:1097608950384:web:45ddb1ce5e3de851037ab5",
  measurementId: "G-12X5775GJ8"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Analytics (optional)
const analytics = getAnalytics(app);

// Initialize Firestore
const db = getFirestore(app);

// Initialize Storage
const storage = getStorage(app);

// Export the services for use in your app
export { app, analytics, db, storage };
